'use client';

import React from 'react';
import { CategoryListSkeleton, ProductListSkeleton } from '@/_components/skeletons';
import { TagLine } from '@/_components/TagLine';
import { InlineSearch } from '@/_components/search/InlineSearch';

export default function loading() {
  return (
    <div className='surface-10 border-1 border-100 border-round-md'>
      <TagLine />
      <div className="container pb-4">
        <div className="ennix-cat-mobile-search">
          <InlineSearch />
        </div>
        <CategoryListSkeleton />
        <ProductListSkeleton count={8} />
      </div>
    </div>
  );
}
